<div class="d-grid align-items-center justify-content-center w-100">
   <div class="login mt-0 box-bg form-padding mw600">
      <!-- <ngx-loading [show]="loading"></ngx-loading> -->
      <div class="login-title primary-header">Sign Up</div>
      <div class="login-title-msg">Welcome to iDEC Face</div>
      <div class="floating-form" [formGroup]="registrationForm">
         <div class="d-flex justify-content-center  align-items-center w-100 h-100">
            <div class="loaderSvg d-flex align-items-center justify-content-center">
            </div>
         </div>
         <!--photo div-->
         <div class="field">
            <div class="position-relative d-flex justify-content-center" appDrag fileType='image/'
               (files)="filesDropped($event)">
               <div class="pic-display-box">
                  <div class="position-relative d-photo-person">
                     <img *ngIf="!imgURL" class=" w-100 h-100 card-img-top rounded-circle" alt=""
                        src="../../assets/images/default.jpg" />
                     <img *ngIf="imgURL" alt="" [src]="imgURL" class="w-100 h-100">
                  </div>
                  <div class="text-right align-helmet cursor" *ngIf="!imgURL"
                     (click)="imageInput.value=''; imageInput.click()"><em class="fas fa-camera camera-icon"></em>
                  </div>
                  <div class="text-right align-helmet cursor" *ngIf="imgURL"
                     (click)="imageInput.value='';deleteImage()">
                     <em class="fas fa-trash-alt camera-icon"></em>
                  </div>
               </div>
            </div>
            <input #imageInput type="file" (change)="onImageSelected($event)" style="display:none;" accept="image/*">
         </div>
         <!--Photo div ends-->
         <!--common div starts-->

         <div class="d-flex flex-column ">
            <div class="mt-top-2 modal-form d-flex">
               <mat-form-field class="field">
                  <mat-label>Organisation</mat-label>
                  <input matInput oninput="this.value = this.value.toUpperCase()" formControlName="organisation">
                  <ng-container *ngIf="regSubmitted && regFormValues['organisation'].errors">
                     <mat-error *ngIf="regFormValues['organisation'].errors?.['required']">
                        <em class="fas fa-exclamation-circle mr-2"></em>Organisation is required
                     </mat-error>
                     <mat-error *ngIf="regFormValues['organisation'].errors?.['pattern']">
                        <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
                     </mat-error>
                  </ng-container>
               </mat-form-field>
            </div>
            <div class="modal-form d-flex">
               <app-name-form formControlName="name"></app-name-form>
            </div>
            <div class="modal-form d-flex">
               <mat-form-field>
                  <mat-label>EmpId</mat-label>
                  <input matInput formControlName="empId">
                  <ng-container *ngIf="regSubmitted && regFormValues['empId'].errors">
                     <mat-error *ngIf="regFormValues['empId'].errors?.['required']">
                        <em class="fas fa-exclamation-circle mr-2"></em>EmpId is required
                     </mat-error>
                  </ng-container>
               </mat-form-field>
            </div>

            <div class="modal-form d-flex">
               <app-personal-info-form formControlName="personalInfo"></app-personal-info-form>
            </div>
            <div class="modal-form d-flex">
               <app-contact-form formControlName="contact" pageType='signup'></app-contact-form>
            </div>
         </div>
         <!--common div ends-->
         <div class="modal-form d-flex -text-area-field-height">
            <mat-form-field>
               <mat-label>Comment</mat-label>
               <textarea matInput cdkTextareaAutosize formControlName="comment" #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
            </mat-form-field>
         </div>
         <div class="d-flex justify-content-center">
            <div class="err-mssg-domain text-danger mb-2" *ngIf="regErrorMessage">
               <em class="fas fa-exclamation-circle mr-2"></em>{{regErrorMessage}}
            </div>
         </div>

         <div class="btn-basket">
            <button mat-raised-button color="primary" (click)="reset()">
               Reset
            </button>
            <button mat-raised-button color="primary" (click)="signup()">
               Sign up
            </button>
         </div>



      </div>
   </div>

   <div class="d-flex justify-content-center">
      <div class="linkStyle ft-12 mt-2">Already Registered? <label class="cursor text-underline ft-12"
            (click)="logIn()"><u *ngIf="!userId">Login Here</u><u *ngIf="userId">Home</u></label>
      </div>
   </div>
</div>